import React from 'react';
import styled from 'styled-components';

interface ResponsiveViewProps {
  children: React.ReactNode;
}

const ResponsiveContainer = styled.div`
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    background-color: #f5f5f5;
  }
`;

const ResponsiveContent = styled.div`
  width: 100%;
  
  @media (min-width: 768px) {
    max-width: 360px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 40px;
  }
`;

const ResponsiveView: React.FC<ResponsiveViewProps> = ({ children }) => {
  return (
    <ResponsiveContainer>
      <ResponsiveContent>
        {children}
      </ResponsiveContent>
    </ResponsiveContainer>
  );
};

export default ResponsiveView;
